import { z } from "zod/v4";

export const zodLoginData = z.object({
  password: z.string().min(1),
  username: z.string().min(1),
});

export type LoginData = z.infer<typeof zodLoginData>;
